import { connect } from 'react-redux';
import CardsPanel from './CardsPanel';
import {
  getCardsToDisplay,
  getCurrentSelection,
  setActiveSelfAuthTab,
} from '../store/selfAuthorizationsSlice';

const mapStateToProps = state => ({
  activeSelfAuthTab: state.loadingManagement.selfAuthorizations.activeSelfAuthTab,
  authorizationSelection: state.loadingManagement.filters.authorizationSelection,
  currentSelection: getCurrentSelection(state),
  extendedLoadingSelection: state.loadingManagement.filters.extendedLoadingSelection,
  selfAuthorizationCards: getCardsToDisplay(state),
  selfAuthorizations: state.loadingManagement.selfAuthorizations.selfAuthorizations,
  selfAuthorizationsPending: state.loadingManagement.selfAuthorizations.selfAuthorizationsPending,
});

export default connect(mapStateToProps, { setActiveSelfAuthTab })(CardsPanel);
